import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import api from '../../services/axios';
import BanksSearchBar from './BanksSearchBar';
import BanksTable from './BanksTable';
import Pagination from '../controls/Pagination';

const ShowBankEntries = (props) => {
  const { t } = useTranslation();
  const [bankEntries, setBankEntries] = useState([]);
  const [bankToFind, setBankToFind] = useState('');
  const [currrentPage, setCurrrentPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [errMsg, setErrMsg] = useState('');
  const [saldoInicial, setSaldoInicial] = useState(0);
  
  // Fechas por defecto: última semana
  const getDefaultStartDate = () => {
    const date = new Date();
    date.setDate(date.getDate() - 7);
    return date.toISOString().slice(0, 10);
  };
  const getDefaultEndDate = () => {
    return new Date().toISOString().slice(0, 10);
  };
  
  const [startDate, setStartDate] = useState(getDefaultStartDate());
  const [endDate, setEndDate] = useState(getDefaultEndDate());
  const [originId, setOriginId] = useState('');
  const [textToFind, setTextToFind] = useState('');

  useEffect(() => {
    getAllBankEntries();
  }, [currrentPage, bankToFind, startDate, endDate, originId, textToFind, perPage]);

  const getAllBankEntries = async () => {
    try {
      let url = "/bank_entries_react?page=" + currrentPage + "&per_page=" + perPage;
      if (bankToFind) url += "&bank_id=" + bankToFind;
      if (startDate) url += "&startDate=" + startDate;
      if (endDate) url += "&endDate=" + endDate;
      if (originId) url += "&origin_id=" + originId;
      if (textToFind) url += "&textToFind=" + textToFind;

      const response = await api.get(url, {
        headers: {
          'Authorization': 'Bearer ' + props.loginParameters.accesToken
        }
      });
      setBankEntries(response.data.paginator.data);
      setLastPage(response.data.paginator.last_page);
      setSaldoInicial(response.data.totals?.saldoInicial || 0);
    } catch (err) {
      if (!err?.response) {
        setErrMsg('No Server Response');
      } else if (err.response?.status === 401) {
        setErrMsg('Unauthorized');
      } else {
        setErrMsg('Error loading data');
      }
    }
  };

  const paginate = (page) => {
    setCurrrentPage(page);
  };

  return (
    <div style={{ padding: "20px" }}>
      <BanksSearchBar
        t={t}
        loginParameters={props.loginParameters}
        saldoInicial={saldoInicial}
        bankToFind={bankToFind}
        setCurrrentPage={setCurrrentPage}
        setBankToFind={setBankToFind}
        startDate={startDate}
        setStartDate={setStartDate}
        endDate={endDate}
        setEndDate={setEndDate}
        originId={originId}
        setOriginId={setOriginId}
        textToFind={textToFind}
        setTextToFind={setTextToFind}
        perPage={perPage}
        setPerPage={setPerPage}
        onRefresh={getAllBankEntries}
        loginParameters={props.loginParameters}
        saldoInicial={saldoInicial}
        getDefaultStartDate={getDefaultStartDate}
        getDefaultEndDate={getDefaultEndDate}
      />
      <BanksTable
        onRefresh={getAllBankEntries}
        loginParameters={props.loginParameters}
        saldoInicial={saldoInicial}
        bankEntries={bankEntries}
        t={t}
      />
      <h4 className={errMsg ? "errmsg" : "offscreen"} aria-live="assertive">{errMsg}</h4>
      <Pagination
        lastPage={lastPage}
        currrentPage={currrentPage}
        paginate={paginate}
      />
    </div>
  );
};

export default ShowBankEntries;
